import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getHelixUIMode } from 'utils/helix';
import useVisibleScreenContext from 'hooks/useVisibleScreenContext';
import Heading from 'components/Heading';
import Card from 'components/Card';
import PercentageDisc from 'components/PercentageDisc';
import Flag from 'components/Flag';
import UserGeneratedText from 'components/UserGeneratedText';
import Stack from 'components/Stack';
import TextLink from 'components/TextLink';
import Icon from 'components/Icon';
import Text from 'components/Text';
import IconDisc from 'components/IconDisc';
import QuoteSection from './QuoteSection';
import ButtonRow from './ButtonRow';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function SkillScoreFlagCard(_ref) {
  var _skill$skillUsage, _skill$skillUsage2;
  var _ref$canShowButtonRow = _ref.canShowButtonRow,
    canShowButtonRow = _ref$canShowButtonRow === void 0 ? true : _ref$canShowButtonRow,
    isCurrentUser = _ref.isCurrentUser,
    userId = _ref.userId,
    skill = _ref.skill,
    getLink = _ref.getLink;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _getHelixUIMode = getHelixUIMode(),
    showScores = _getHelixUIMode.showScores;
  var wasSkillUsed = skill === null || skill === void 0 ? void 0 : skill.id; // Has an analysis record for this skill

  var positiveSkillUsage = (skill === null || skill === void 0 || (_skill$skillUsage = skill.skillUsage) === null || _skill$skillUsage === void 0 ? void 0 : _skill$skillUsage.positive) || [];
  var negativeSkillUsage = (skill === null || skill === void 0 || (_skill$skillUsage2 = skill.skillUsage) === null || _skill$skillUsage2 === void 0 ? void 0 : _skill$skillUsage2.negative) || [];
  var showButtonRow = canShowButtonRow && isCurrentUser;

  // While this card is scrolled into view, tell AI agents which skill the
  // user is looking at. Agents fetch the skill's full analysis by id via
  // MCP.
  var watchedElementRef = useVisibleScreenContext(_objectSpread(_objectSpread({
    description: wasSkillUsed ? "Skill score card for \"".concat(skill.name, "\"") : "Skill card for \"".concat(skill.name, "\" \u2014 not recorded this period")
  }, skill.skillId && {
    id: skill.skillId
  }), userId && {
    state: {
      userId: userId
    }
  }));
  return /*#__PURE__*/_jsx(Flag, {
    token: showScores ? /*#__PURE__*/_jsx(PercentageDisc, {
      shady: true,
      percentage: skill.score || undefined
    }) : /*#__PURE__*/_jsx(IconDisc, {
      size: "big",
      shady: true,
      name: "asset-fluidbook"
    }),
    align: "top",
    children: /*#__PURE__*/_jsxs(Card, {
      ref: watchedElementRef,
      px: "m",
      py: "s",
      dimmed: !wasSkillUsed,
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h3",
        mb: "s",
        children: /*#__PURE__*/_jsxs(TextLink, {
          stealthy: true,
          as: Link,
          to: getLink({
            skillId: skill.skillId
          }),
          children: [skill.name, /*#__PURE__*/_jsx(Icon, {
            name: "arrow-right",
            size: "unscaled",
            ml: "xs"
          })]
        })
      }), wasSkillUsed ? /*#__PURE__*/_jsxs(Stack, {
        spacing: "s",
        children: [(skill === null || skill === void 0 ? void 0 : skill.summary) && /*#__PURE__*/_jsx(UserGeneratedText, {
          text: skill.summary
        }), (skill === null || skill === void 0 ? void 0 : skill.suggestion) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Heading, {
            as: "h4",
            mb: "xs",
            size: "small",
            children: t('property_suggestions')
          }), /*#__PURE__*/_jsx(UserGeneratedText, {
            text: skill.suggestion
          })]
        }), (positiveSkillUsage.length > 0 || negativeSkillUsage.length > 0) && /*#__PURE__*/_jsx(QuoteSection, {
          positiveSkillUsage: positiveSkillUsage,
          negativeSkillUsage: negativeSkillUsage
        }), showButtonRow && /*#__PURE__*/_jsx(ButtonRow, {
          isCurrentUser: isCurrentUser,
          userId: userId,
          skillId: skill.skillId,
          skillName: skill.name,
          summary: skill.summary,
          suggestion: skill.suggestion
        })]
      }) : /*#__PURE__*/_jsxs(Stack, {
        spacing: "s",
        children: [/*#__PURE__*/_jsx(Text, {
          dimmed: true,
          children: t('skills_empty_state_skill_not_recorded_during_meeting')
        }), showButtonRow && /*#__PURE__*/_jsx(ButtonRow, {
          isCurrentUser: isCurrentUser,
          userId: userId,
          skillId: skill.skillId,
          skillName: skill.name
        })]
      })]
    })
  });
}
export default SkillScoreFlagCard;